import { render } from "./CancelledOrdersView.vue?vue&type=template&id=1d21b518"
import script from "./CancelledOrdersView.vue?vue&type=script&lang=js"
export * from "./CancelledOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__